export enum PaymentStatusEnum {
    PENDING = 10,
    APPROVED  = 15,
    AUTHORIZED  = 20,
    PAID   = 30
}